import { Component, OnInit } from '@angular/core';
import { GlobalState } from '../shared/global.state';
// import {datachoice,addForm} from './service';
import { ApiServiceAssessment } from './service';
@Component({
  selector: 'app-assessment',
  templateUrl: './assessment.component.html',
  styleUrls: ['./assessment.component.css']
})
export class AssessmentComponent implements OnInit {
  public demo = [];
  choice: [];
  number: number = 1;
  score = [];
  constructor(
    private _state: GlobalState,
    private apiService: ApiServiceAssessment
  ) {

  }

  ngOnInit(): void {
    this.getData()
    this.demo = [{
      id: 1,
      name: 'ระบบจองรถ'
    },
    {
      id: 2,
      name: 'ระบบคำสั่ง'
    },
    {
      id: 3,
      name: 'ระบบแผน'
    },
    {
      id: 4,
      name: 'ระบบบันทึกภาระงานสายสนับสนุน'
    },
    {
      id: 5,
      name: 'ระบบบันทึกภาระงานคณาจารย์'
    }
    ];
  }

  getData(): void {
    this.apiService.getData()
      .subscribe(data => {
        this.choice = data.data;
      });
  }

  onSubmit(e): void {
    // โค้ดที่จะทำงานเมื่อคลิกปุ่ม  
    this.score = [];
    e.preventDefault();
    for (let index = 0; index < e.target.length; index++) {
      if (e.target[index].type === 'radio' && e.target[index].checked) {
        this.score.push(e.target[index].value)
      }
    }
    let names = ["score0", "score1", "score2", "score3", "score4", "score5"]
    let results = [];
    let test;
    results = names.map(function (el, index) {
      test = document.querySelector("input[name='" + el + "']:checked")
      console.log(test);
      if (test != null ) {
        return test.value
      }
    });
    console.log(results);
    // console.log(e.target.score);
    // const data = {
    //   score: this.score,
    //   detail_other: e.target.detail_other.value,
    // }
    // console.log(this.apiService.postData(data));
    // console.log(this.score);

  }

}
